$(document).ready(function () {
  Sceon.CompanyComments.overlayContainer = '.comments-section';
  Sceon.CompanyComments.container = '.comments-container';
  Sceon.CompanyComments.formContainer = '.add-comment-container';

  Sceon.CompanyComments.Init = function () {
    Sceon.CompanyComments.InitAddForm();
    Sceon.CompanyComments.InitCloseButton();
    Sceon.CompanyComments.InitFormSubmit();
  };

  Sceon.CompanyComments.GetComments = function (page = 0) {
    const container = $(Sceon.CompanyComments.overlayContainer);
    let overlay = new Sceon.Overlay(container, {
      loader: '/img/loader-tiny.gif',
      offset: { bottom: 0, top: 0 },
    });
    overlay.enable();

    let url = 'get-comments?';
    if (typeof page != 'undefined' && page) {
      url = url + 'page=' + page;
    }
    $.ajax({
      url: url,
      method: 'GET',
      success: function (resp) {
        $(Sceon.CompanyComments.container).replaceWith(resp);
        overlay.disable();
        let top = $(Sceon.CompanyComments.container).offset().top - 50;
        $('html, body').animate(
          {
            scrollTop: top,
          },
          500,
        );
      },
    });
  };
  Sceon.CompanyComments.InitAddForm = function () {
    $(document).on('click', '.add-comment-btn', function () {
      if (
        String(Sceon.CompanyComments.is_member) === 'true' ||
        Sceon.CompanyComments.can_reply === 1
      ) {
        event.preventDefault();
        Sceon.CompanyComments.GetCommentForm($(this));
      } else {
        Sceon.Popup.Show();
      }
    });
  };

  Sceon.CompanyComments.GetCommentForm = function (el) {
    let cc_overlay = new Sceon.Overlay(
      $(Sceon.CompanyComments.overlayContainer),
      {
        loader: '/imgr/loader-tiny.gif',
        offset: { bottom: 0, top: 0, left: '1px' },
      },
    );
    cc_overlay.enable();
    $('.reply-place').html('');
    $('#add-comment-form').html('');
    $('#comment_added').addClass('hidden');

    $.ajax({
      url: '/comments/ajax-add-comment',
      method: 'GET',
      data: {
        profile_id: Sceon.CompanyComments.company_id,
      },
      success: async function (resp) {
        if (resp.trim().length > 0) {
          // let token;
          // try {
          //   token = await grecaptcha.execute(envConfigs.reCAPTCHA_site_key, {
          //     action: 'write_comment',
          //   });
          // } catch (e) {
          //   token = 'some shit token';
          // }

          $('#add-comment-form').html(resp);

          // $('input[name="captcha"]').val(token);
        }
        setTimeout(() => {
          cc_overlay.disable();
        }, 300);
      },
    });
  };

  Sceon.CompanyComments.InitCloseButton = function () {
    $(document).on('click', '.close-form', function () {
      $('#add-comment-form').html('');
      $('#comment_added').addClass('hidden');
    });
  };

  Sceon.CompanyComments.InitFormSubmit = function () {
    $(document).on(
      'click',
      '.add-comment-container .submit-form',
      function (e) {
        e.preventDefault();
        let cc_overlay = new Sceon.Overlay(
          $(Sceon.CompanyComments.formContainer),
          {
            loader: '/imgr/loader-tiny.gif',
            offset: { bottom: 0, top: 0, left: '1px' },
          },
        );
        cc_overlay.enable();

        $.ajax({
          url: '/comments/add-company-comment',
          method: 'POST',
          data: $('.add-comment-container').serialize(),
          success: async function (resp) {
            if (resp.status === 'error') {
              // let token;
              // try {
              //   token = await grecaptcha.execute(
              //     envConfigs.reCAPTCHA_site_key,
              //     { action: 'write_comment' },
              //   );
              // } catch (e) {
              //   token = 'some shit token';
              // }
              // $('input[name="captcha"]').val(token);
              $('.error-msg').html('').addClass('hidden');
              for (const err in resp.msgs) {
                let $el = $(`#${err}-error`);
                $el.html(resp.msgs[err]);
                $el.removeClass('hidden');
              }
            } else {
              $('#comment_added').removeClass('hidden');
              $('.add-comment-content').html('');
            }
            cc_overlay.disable();
          },
        });
      },
    );
  };

  Sceon.CompanyComments.Init();
});
